import { pubsub } from './pubsub';

// takes the stored tasks of one project and
// bundles them in a fragment
// to be sent to the UI
export function processTaskStored() {
	pubsub.subscribe('taskStored', renderTasks);
}

export function renderTasks(tasks) {
	const fragment = new DocumentFragment();
	const doneTaksContainer = document.createElement('details');
	const summaryDoneTasksContainer = document.createElement('summary');
	summaryDoneTasksContainer.textContent = 'Expand done tasks';
	doneTaksContainer.appendChild(summaryDoneTasksContainer);
	doneTaksContainer.classList.add('done-tasks-container');
	for (let i = 0; i < tasks.length; i++) {
		// task container
		const taskContainer = document.createElement('div');
		taskContainer.classList.add('task-container');

		// checkbox
		const taskCheckbox = document.createElement('input');
		taskCheckbox.type = 'checkbox';
		taskCheckbox.checked = tasks[i].done;
		taskCheckbox.classList.add('task-checkbox');
		taskContainer.appendChild(taskCheckbox);
		// checkbox event listener
		taskCheckbox.setAttribute('data-index', tasks[i].taskId);
		taskCheckbox.addEventListener('change', editTaskDoneStatus);

		// task name
		const taskName = document.createElement('div');
		taskName.classList.add('task-name');
		taskName.textContent = tasks[i].title;
		taskContainer.appendChild(taskName);

		// container for the task controls
		const taskControls = document.createElement('div');
		taskControls.classList.add('task-controls-container');
		taskContainer.appendChild(taskControls);

		// task date
		const taskDate = document.createElement('input');
		taskDate.type = 'date';
		taskDate.value = tasks[i].duedate;
		taskDate.classList.add('task-date');
		taskControls.appendChild(taskDate);
		// add event listener
		taskDate.setAttribute('data-index', tasks[i].taskId);
		taskDate.addEventListener('change', editTaskDate);

		// additional container for the buttons
		const taskButtonsContainer = document.createElement('div');
		taskButtonsContainer.classList.add('task-buttons-container');
		taskControls.appendChild(taskButtonsContainer);

		// task details button
		const taskDetailsButton = document.createElement('button');
		taskDetailsButton.textContent = 'Info';
		taskDetailsButton.classList.add('task-details-button');
		taskButtonsContainer.appendChild(taskDetailsButton);
		// add event listener
		taskDetailsButton.setAttribute('data-index', tasks[i].taskId);
		taskDetailsButton.addEventListener('click', openTaskDetailsModal);

		// task edit button
		const taskEditButton = document.createElement('button');
		taskEditButton.classList.add('task-edit-button');
		renderEditIcon(taskEditButton);
		taskButtonsContainer.appendChild(taskEditButton);
		// add event listener
		taskEditButton.setAttribute('data-index', tasks[i].taskId);
		taskEditButton.addEventListener('click', openTaskEditModal);

		// task delete button
		const taskDeleteButton = document.createElement('button');
		taskDeleteButton.classList.add('task-delete-button');
		renderDeleteIcon(taskDeleteButton);
		taskButtonsContainer.appendChild(taskDeleteButton);
		// add event listener
		taskDeleteButton.setAttribute('data-index', tasks[i].taskId);
		taskDeleteButton.addEventListener('click', sendTaskDeleteRequest);

		// adding a classlist depending on the priority of the task
		// this renders the left border in different colors
		// depending on the tasks's priority
		switch(tasks[i].priority) {
			case '3':
				taskContainer.classList.add('high-priority-task');
				break;
			case '2':
				taskContainer.classList.add('medium-priority-task');
				break;
			case '1':
				taskContainer.classList.add('low-priority-task');
				break;
		}

		if (tasks[i].done) {
			doneTaksContainer.appendChild(taskContainer);
		} else {
			fragment.appendChild(taskContainer);
		}

		fragment.appendChild(doneTaksContainer);
	}
	pubsub.publish('taskRendered', fragment);
}

// render task edit icon
export function renderEditIcon(node) {
	const fragment = new DocumentFragment();
	// creating the svg element
	const iconSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
	const iconPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
	// setting svg attributes
	iconSvg.setAttribute('fill', 'black');
	iconSvg.setAttribute('viewBox', '0 0 24 24');
	iconPath.setAttribute('d', 'M10 20H6V4H13V9H18V12.1L20 10.1V8L14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H10V20M20.2 13C20.3 13 20.5 13.1 20.6 13.2L21.9 14.5C22.1 14.7 22.1 15.1 21.9 15.3L20.9 16.3L18.8 14.2L19.8 13.2C19.9 13.1 20 13 20.2 13M20.2 16.9L14.1 23H12V20.9L18.1 14.8L20.2 16.9Z');
	// adding css class
	iconSvg.classList.add('task-edit-icon');
	// appending nodes
	iconSvg.appendChild(iconPath);
	fragment.appendChild(iconSvg);
	return node.appendChild(fragment);
}

// render task delete icon
export function renderDeleteIcon(node) {
	const fragment = new DocumentFragment();
	// creating the svg element
	const iconSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
	const iconPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
	// setting svg attributes
	iconSvg.setAttribute('fill', 'black');
	iconSvg.setAttribute('viewBox', '0 0 24 24');
	iconPath.setAttribute('d', 'M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19M8,9H16V19H8V9M15.5,4L14.5,3H9.5L8.5,4H5V6H19V4H15.5Z');
	// adding css class
	iconSvg.classList.add('task-delete-icon');
	// appending nodes
	iconSvg.appendChild(iconPath);
	fragment.appendChild(iconSvg);
	return node.appendChild(fragment);
}

// edits the 'done' status of a task displayed in the UI list of tasks
function editTaskDoneStatus() {
	const statusInfo = {
		done: this.checked,
		index: this.dataset.index,
	}
	pubsub.publish('changeTaskStatus', statusInfo);
}

function editTaskDate() {
	const dateInfo = {
		date: this.value,
		index: this.dataset.index,
	}
	pubsub.publish('changeTaskDate', dateInfo);
}

// function that opens the modal with task info
function openTaskDetailsModal() {
	const index = this.dataset.index;
	pubsub.publish('findTaskInfo', index);
}

// gets triggered when the user wants to edit the task
// event flow: tasks-render > local-storage > tasks-form > local-storage > homepage-ui
function openTaskEditModal() {
	const index = this.dataset.index;
	pubsub.publish('openPrefilledTaskModal', index);
}

// function attached to the task delete button
// send a pubsub delete request to local-storage.js
function sendTaskDeleteRequest() {
	const index = this.dataset.index;
	pubsub.publish('deleteTaskRequest', index);
}

// function to render tasks filtered
// without the ability to edit items
// except their 'done' status
export function processTasksFiltered() {
	pubsub.subscribe('tasksFiltered', renderTasksFilterd);
}

function renderTasksFilterd(tasks) {
	const fragment = new DocumentFragment();
	for (let i = 0; i < tasks.length; i++) {
		// create the task container
		const taskContainer = document.createElement('div');
		taskContainer.classList.add('filter-task-container');

		// checkbox
		const taskCheckbox = document.createElement('input');
		taskCheckbox.type = 'checkbox';
		taskCheckbox.checked = tasks[i].done;
		taskCheckbox.classList.add('filter-task-checkbox');
		taskContainer.appendChild(taskCheckbox);
		// checkbox event listener
		taskCheckbox.setAttribute('data-index', tasks[i].taskId);
		taskCheckbox.addEventListener('change', editTaskDoneStatus);

		// task name
		const taskName = document.createElement('div');
		taskName.classList.add('filter-task-name');
		taskName.textContent = tasks[i].title;
		taskContainer.appendChild(taskName);

		// task date
		const taskDate = document.createElement('div');
		taskDate.classList.add('filter-task-date');
		taskDate.textContent = tasks[i].duedate;
		taskContainer.appendChild(taskDate);

		// task details button
		const taskDetailsButton = document.createElement('button');
		taskDetailsButton.textContent = 'Info';
		taskDetailsButton.classList.add('filter-task-details-button');
		taskContainer.appendChild(taskDetailsButton);
		// add event listener
		taskDetailsButton.setAttribute('data-index', tasks[i].taskId);
		taskDetailsButton.addEventListener('click', openTaskDetailsModal);

		// appending the task container to the fragment
		fragment.appendChild(taskContainer);

		// adding a classlist depending on the priority of the task
		// this renders the left border in different colors
		// depending on the tasks's priority
		switch(tasks[i].priority) {
			case '3':
				taskContainer.classList.add('high-priority-task');
				break;
			case '2':
				taskContainer.classList.add('medium-priority-task');
				break;
			case '1':
				taskContainer.classList.add('low-priority-task');
				break;
		}
	}
	pubsub.publish('taskRendered', fragment);
}

// filters the function by their 'done: true' status
function filterByDone(item) {
	return item.done;
}
